import { useEffect } from 'react'

import { useAppContext } from '@/App.context'
// todo: clean up the icons and test the ios setup
// @ts-ignore
import csiFavicon from '@/assets/img/csi/favicon.ico'
import csiLogo from '@/assets/img/csi/logo.png'
import elkjopFavicon from '@/assets/img/elkjop/favicon.png'
import elkjopLogo from '@/assets/img/elkjop/favicon.png'
import iceFavicon from '@/assets/img/ice/ice_favicon.png'
import iceLogo from '@/assets/img/ice/ice_icon.png'
import ikommFavicon from '@/assets/img/ikomm/ikomm_control_favicon.png'
import ikommLogo from '@/assets/img/ikomm/ikomm_control_logo_white.png'
import komplettLogo from '@/assets/img/komplett/komplett-logo-favicon.png'
import mobitFavicon from '@/assets/img/mobit/favicon.png'
import mobitLogo from '@/assets/img/mobit/favicon.png'
import skytechFavicon from '@/assets/img/skytech/favicon-orange.png'
import skytechLogo from '@/assets/img/skytech/logo-orange.png'
import teliaFavicon from '@/assets/img/telia/telia_logo.svg'
import teliaLogo from '@/assets/img/telia/telia_logo_text.svg'
import threeStepITFavicon from '@/assets/img/threeStepIT/threeStepIT-favicon.svg'
import threeStepIT from '@/assets/img/threeStepIT/threeStepIT-logo.svg'
import tietoEvryFavicon from '@/assets/img/tieto-evry/tietoevry_favicon.png'
import tietoEvryLogo from '@/assets/img/tieto-evry/tietoevry_logo.jpeg'

const MetaTags = () => {
  const { whiteLabel } = useAppContext()
  useEffect(() => {
    refreshMeta()
  })

  const refreshMeta = () => {
    switch (whiteLabel) {
      case 'ice':
        setDocFavicon(iceFavicon)
        setLogo(iceLogo)
        setDocTitle('Kostkontroll Total')
        break
      case 'tietoevry':
        setDocFavicon(tietoEvryFavicon)
        setLogo(tietoEvryLogo)
        setDocTitle('TietoEVRY Control')
        break
      case 'elkjop':
        setDocFavicon(elkjopFavicon)
        setLogo(elkjopLogo)
        setDocTitle('Control')
        break
      case 'telia':
        setDocFavicon(teliaFavicon)
        setLogo(teliaLogo)
        setDocTitle('Telia Kontroll')
        break
      case 'mobit':
        setDocFavicon(mobitFavicon)
        setLogo(mobitLogo)
        setDocTitle('Mobit Control')
        break
      case 'csi':
        setDocFavicon(csiFavicon)
        setLogo(csiLogo)
        setDocTitle('CSI Control')
        break
      case 'threeStepIT':
        setDocFavicon(threeStepITFavicon)
        setLogo(threeStepIT)
        setDocTitle('3stepIT Control')
        break
      case 'komplett':
        setDocFavicon(komplettLogo)
        setLogo(komplettLogo)
        setDocTitle('Komplett Control')
        break
      case 'ikomm':
        setDocFavicon(ikommFavicon)
        setLogo(ikommLogo)
        setDocTitle('Control')
        break
      default:
        setDocFavicon(skytechFavicon)
        setLogo(skytechLogo)
        setDocTitle('Skytech Control')
    }
  }

  const setDocTitle = (title: string) => {
    document.title = title
  }

  const setDocFavicon = (file: string) => {
    const favicon = document.querySelector("link[rel*='icon']")
    // @ts-ignore
    favicon.href = file
  }

  const setLogo = (file: string) => {
    const favicon = document.querySelector("link[rel*='apple-touch-icon']")
    // @ts-ignore
    favicon.href = file
  }

  return null
}

export default MetaTags
